__turbopack_context__.v({
  "author_name": "styles-module-scss-module__fh0MTa__author_name",
  "card": "styles-module-scss-module__fh0MTa__card",
  "card_content": "styles-module-scss-module__fh0MTa__card_content",
  "card_image": "styles-module-scss-module__fh0MTa__card_image",
  "date_range": "styles-module-scss-module__fh0MTa__date_range",
  "event_details": "styles-module-scss-module__fh0MTa__event_details",
  "heading": "styles-module-scss-module__fh0MTa__heading",
  "loading_placeholder": "styles-module-scss-module__fh0MTa__loading_placeholder",
  "theme_basic": "styles-module-scss-module__fh0MTa__theme_basic",
  "theme_large": "styles-module-scss-module__fh0MTa__theme_large",
});
